import { h, Component } from 'preact'
import { Router, route } from 'preact-router'
import { Provider } from 'unistore/preact'

import Header from 'app/components/Header'
import Dashboard from 'app/pages/Dashboard'

import store from 'app/store'
import PrivateRoute from 'app/components/PrivateRoute'
import Settings from 'app/pages/Settings'
import Login from 'app/pages/Login'
import SignUp from './pages/SignUp'
import Landing from './pages/Landing'
import NotFound from './pages/NotFound'

import Alert from 'react-s-alert'
import { connect } from './store'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Tag from './pages/Tag'
import Tags from './pages/Tags'
import Submit from './pages/Submit'
import { Footer } from './components/Footer'
import { Privacy } from './pages/Privacy'
import { Terms } from './pages/Terms'

class Routes {
  handleRoute = e => {
    this.currentUrl = e.url
  }

  render(props) {
    const isAuth = props.auth && props.auth.accessToken

    const privateRoutes = [
      <PrivateRoute path="/" component={Dashboard} />,
      <PrivateRoute path="/settings" component={Settings} />,
      <PrivateRoute path="/tags" component={Tags} />,
      <PrivateRoute path="/tags/:name" component={Tag} />,
      <PrivateRoute path="/submit" component={Submit} />,
      <Terms path="/terms" />,
      <Privacy path="/privacy" />,
      <NotFound default />,
    ]

    const publicRoutes = [
      <Landing path="/" />,
      <Login path="/login" />,
      <SignUp path="/join" />,
      <ResetPassword path="/reset" />,
      <ForgotPassword path="/forgot" />,
      <Privacy path="/privacy" />,
      <Terms path="/terms" />,
      <NotFound default />,
    ]

    return <Router onChange={this.handleRoute}>{isAuth ? privateRoutes : publicRoutes}</Router>
  }
}

const RoutesConnected = connect(
  'auth',
  Routes,
)

export default class Root extends Component {
  handleRoute = e => {
    this.currentUrl = e.url
  }

  render() {
    return (
      <Provider store={store}>
        <div id="app">
          <div class="wrapper">
            <Header />
            <main class="content container mt-5">
              <RoutesConnected />
              <Alert timeout={5000} stack={{ limit: 3 }} html={false} position="bottom-right" />
            </main>
          </div>
          <Footer />
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./Root.js